export const Footer = () => {
  const columns = [
    {
      heading: 'Platform',
      links: [
        { label: 'How It Works', href: '#how-it-works' },
        { label: 'Services', href: '#services' },
        { label: 'Pricing', href: '#pricing' },
        { label: 'Reviews', href: '#testimonials' },
      ],
    },
    {
      heading: 'Get Started',
      links: [
        { label: 'Build Your Team', href: 'https://vibe.hirex8.com/register?type=client' },
        { label: 'Book a Call', href: 'https://cal.com/matching-expert/30min' },
        { label: 'Talent Network', href: 'https://hirex8.com/talent' },
      ],
    },
  ];

  return (
    <footer className="border-t border-border bg-background">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr] gap-10 mb-14">
          {/* Brand Column */}
          <div>
            <a href="/" data-testid="footer-logo" className="inline-flex items-baseline no-underline">
              <span className="font-black text-[20px] tracking-tight text-foreground leading-none">
                [<span className="text-primary">Hx8</span>]
              </span>
            </a>
            <p className="text-[13px] text-muted-foreground mb-5">
              a{' '}
              <a
                href="https://concepts.io/ecosystem"
                className="text-muted-foreground"
                style={{ transition: 'color 0.15s ease' }}
                onMouseEnter={e => e.target.style.color = 'hsl(0 0% 11%)'}
                onMouseLeave={e => e.target.style.color = ''}
              >
                concepts.io
              </a>{' '}
              company
            </p>
            <p className="text-[14px] text-muted-foreground leading-relaxed max-w-[220px]">
              Human+AI talent for agencies that refuse to say no.
            </p>
          </div>

          {/* Link Columns */}
          {columns.map(col => (
            <div key={col.heading}>
              <h4 className="text-[12px] font-semibold uppercase tracking-[0.1em] text-foreground mb-5">
                {col.heading}
              </h4>
              <ul className="space-y-3">
                {col.links.map(link => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-[14px] text-muted-foreground no-underline"
                      style={{transition: 'color 0.15s ease'}}
                      onMouseEnter={e => e.target.style.color = 'hsl(0 0% 11%)'}
                      onMouseLeave={e => e.target.style.color = ''}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Row */}
        <div className="border-t border-border pt-6">
          <p className="text-[13px] text-muted-foreground" data-testid="footer-copyright">
            © 2025 HireX8. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
